module.exports = __webpack_public_path__ + "img/EditorialBallastVergangenheitThumbnail-768.206f233f.jpg";